const firebaseConfig = {
    apiKey: 'AIzaSyCsV-3C_U3ksRXdsZorW9RXy7PifGTR52w',
    authDomain: 'merit-werb.firebaseapp.com',
    projectId: 'merit-werb',
    storageBucket: 'merit-werb.appspot.com',
    messagingSenderId: '1023193104645',
    appId: '1:1023193104645:web:c569ccf902442e2402f76c',
    measurementId: 'G-GHVRHTZN0E',
};

export default firebaseConfig;
